/**
 * @file Checklist template matching helpers for parent-board item flows.
 */

import { appData } from '../../app/state/state.js';

/**
 * Finds and sorts matching checklist templates for a given entity type and its specific types.
 * @param {string} itemType - The base entity type (e.g., 'patient', 'project', 'asset', 'task').
 * @param {Array<string>} itemTypesArray - An array of specific type IDs assigned to the item.
 * @param {boolean} [isManualMatch=false] - If true, includes manual-only templates. If false (default), excludes them.
 * @returns {Array<object>} An array of matching template objects, sorted by sortOrder.
 */
export function getMatchingChecklistTemplates(itemType, itemTypesArray = [], isManualMatch = false) {
    if (!Array.isArray(appData?.checklistTemplates)) {return [];}

    const matchingTemplates = appData.checklistTemplates.filter(template => {
        if (!isManualMatch && template.isManual) {return false;}
        const entityMatch = !template.allowedEntities || template.allowedEntities.length === 0 || template.allowedEntities.includes('all') || template.allowedEntities.includes(itemType);
        const typeMatch = !template.linkedTypes || template.linkedTypes.length === 0 || template.linkedTypes.some(t => itemTypesArray.includes(t));
        return entityMatch && typeMatch;
    });

    return matchingTemplates.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
}
